import React from "react";
import { router } from "@inertiajs/react";
import Table from "../../../../../components/AdminDataTable";
import { VehicleListProps } from "./types";
import { columns } from "./columns";
import type { Vehicle } from "../../../../../types";

const VehicleList: React.FC<VehicleListProps> = ({
  vehicles,
  pagination,
  sort,
  onPaginationChange,
  onSortChange,
  onRowClick,
}) => (
  <Table
    columns={columns}
    data={vehicles}
    rowKey="id"
    onRowClick={({ record }: { record: Vehicle }) =>
      onRowClick
        ? onRowClick(record)
        : router.visit(`/admin/vehicles/${record.id}/edit`)
    }
    sortStatus={
      sort?.order
        ? { columnAccessor: sort.key, direction: sort.order }
        : undefined
    }
    onSortStatusChange={(s) =>
      onSortChange?.({ key: s.columnAccessor as string, order: s.direction })
    }
    totalRecords={
      pagination ? pagination.total_pages * pagination.per_page : undefined
    }
    recordsPerPage={pagination?.per_page}
    page={pagination?.current_page}
    onPageChange={
      pagination && onPaginationChange
        ? (page) => onPaginationChange(page, pagination.per_page)
        : undefined
    }
  />
);

export default VehicleList;
